import { PriceValue } from '@secretescapes/cauldron';
import styled, {
  Scale,
  TypographyVariant,
  typographyVariantProperties,
} from '@secretescapes/falcon';
import { CommonStyledProps, mediaQuery } from 'src/app/utils/styles.utils';

export const Container = styled('div')<CommonStyledProps>`
  display: flex;
  justify-content: space-between;
  gap: ${Scale.m};

  ${({ isMobile }) =>
    !isMobile &&
    `
      @media ${mediaQuery.tablet} {
        > div > div {
          flex-direction: row;
          align-items: baseline;
        }
      }
    `}
`;

export const StyledPriceValue = styled(PriceValue)`
  h4 {
    font-size: ${typographyVariantProperties[TypographyVariant.t4SansBold].tabletFontSize};
  }
`;

export const StyledDiscountBadge = styled('div')`
  & > div {
    height: 100%;

    > span > span > h5 {
      line-height: 1;
    }
  }
`;

export const VerticalDivider = styled('div')`
  width: 1px;
  margin: 0 ${Scale.xs};
  background-color: ${({ theme }) => theme.color.grey20};
`;
